import TabPage from '@/components/TabPage';
import CampusPersonRank from '@/components/campus/CampusPersonRank';
import { useDashboard } from '@/hooks/useDashboard';
import type { DrillTable } from '@/types/dashboard';

export default function Campus() {
  const { drillBlock, openModal } = useDashboard();
  const currentTab = '校园压仓';

  const handlePersonClick = async (drill: DrillTable, name: string) => {
    if (!drill.block || !name) return;
    const res = await drillBlock(currentTab, drill.block, { 人员: name });
    const columns = drill.columns?.length
      ? drill.columns
      : res?.rows?.[0]
        ? Object.keys(res.rows[0])
        : [];
    if (res && res.rows.length > 0) {
      openModal(`${name} - 每日明细`, columns, res.rows);
    } else {
      openModal(`${name} - 每日明细`, columns, []);
    }
  };

  return (
    <TabPage
      chartFullKeys={['category']}
      customDrillRenderer={(drill) => {
        if (drill.title.includes('人员月度累计汇总')) {
          return (
            <CampusPersonRank
              drill={drill}
              onPersonClick={(name) => handlePersonClick(drill, name)}
            />
          );
        }
        return null;
      }}
    />
  );
}
